import { DateTime } from "luxon";

export const fromISODateToRangeFormat = (
  ISODateStartAt: string | null,
  ISODateEndAt: string | null,
  t: (key: string) => string,
  locale = "it",
) => {
  if (!ISODateStartAt || !ISODateEndAt) return null;
  const startDate = DateTime.fromISO(ISODateStartAt).setLocale(locale);
  const endDate = DateTime.fromISO(ISODateEndAt).setLocale(locale);

  if (startDate.hasSame(endDate, "month")) {
    return `${t("from")} ${startDate.toFormat("d")} ${t("to")} ${endDate.toFormat("d MMMM")}`;
  }
  return `${t("from")} ${startDate.toFormat("d MMMM")} ${t("to")} ${endDate.toFormat("d MMMM")}`;
};

export const fromISODateToDateFormatted = (
  ISODate: string | null,
  locale: string = "it",
) => {
  if (!ISODate) return null;
  const date = DateTime.fromISO(ISODate).setLocale(locale);
  return date.toFormat("dd/MM/yyyy");
};

export const fromISOToFormat = (ISODate: string | null) => {
  if (!ISODate) return " - ";
  const date = DateTime.fromISO(ISODate).setLocale("it");
  return date.toFormat("dd/MM/yyyy");
};

export const formatRangeDateToISO = (startDate: string, endDate: string) => {
  const startDateTime = DateTime.fromFormat(startDate, "yyyy-MM-dd");
  const endDateTime = DateTime.fromFormat(endDate, "yyyy-MM-dd");

  if (!startDateTime.isValid) {
    console.error("Invalid start date:", startDateTime.invalidExplanation);
  }

  if (!endDateTime.isValid) {
    console.error("Invalid end date:", endDateTime.invalidExplanation);
  }

  return [
    startDateTime.startOf("day").toISO() ?? "",
    endDateTime.endOf("day").toISO() ?? "",
  ];
};

export const isActiveDate = (expirationDate: string | null) => {
  if (!expirationDate) return false;
  return DateTime.fromISO(expirationDate).toMillis() > Date.now();
};
